module.exports = __webpack_public_path__ + "media/images/service-dfb462b070772d35728f6fae41dc91b5.jpg";